<div class="modal__main">
  <div id="leftPart" class="main__leftpart">
    <div *ngIf="!breakpoints.extraSmall" id="leftPartDiv" class="leftpart__image leftpart__image_big">
      <img id="imgLeft" [src]="sharedDataService.assetsCdn('images/success-photo.png')" alt="" loading="lazy">
    </div>
    <div *ngIf="breakpoints.extraSmall" id="leftPartDiv" class="leftpart__image leftpart__image_big">
      <img id="imgLeft" [src]="sharedDataService.assetsCdn('images/success-photo-mobile.png')" alt="" loading="lazy">
    </div>
  </div>
  <div class="main__rightpart">
    <div class="rightpart__header rightpart__header_bg-orange header-smaller">You’re Finished!</div>
    <div class="rightpart__wrapper border-gray">
      <div class="main__rightpart_sory-gray-block">
        <div id="success">Success!</div>
        <div class="cPar contact-paragraph font-lg-big d-xs-none">
          The text message was released as requested,<br>
          including a secure link to download the iCreditWorks<br>
          App and enable completion of the loan application. </div>
        <div class="cPar contact-paragraph font-lg-big d-xs-flex">
          The text message was<br>
          released as requested,<br>
          including a secure link to<br>
          download the iCreditWorks<br>
          App and enable completion<br>
          of the loan application. </div>
      </div>
    </div>
  </div>
</div>
